module.exports = ApiBase;

function ApiBase () {
  this.baseUrl = INKIVE.C.BASE_URL + 'api/';
}

ApiBase.prototype = _.extend({}, Backbone.Events);
ApiBase.prototype.api = function (route, data, method) {
  method = method || data ? 'POST' : 'GET';
  const deferred = $.Deferred();

  $.ajax({
    type: method,
    url: this.baseUrl + route,
    data,
    success: function (response) {
      deferred.resolve(response);
    },
    error: function () {
      deferred.reject('API call error');
    }
  });

  return deferred.promise();
};

ApiBase.prototype.init = function () {
  const deferred = $.Deferred();

  if (this.data) {
    deferred.resolve(clone(this.data));
  } else {
    this.api(this.resource).then(_.bind(function (data) {
      this.data = data;
      deferred.resolve(clone(data));
    }, this), function (err) {
      deferred.reject(err + ' | API Init error');
    });
  }

  return deferred.promise();

  function clone (data) {
    return _.isArray(data)
      ? _.toArray($.extend(true, {}, data))
      : $.extend(true, {}, data);
  }
};
